module.exports = __webpack_public_path__ + "static/github-daa5c7174c7dc0080d83685ad2a01096.jpg";